import(/* webpackMode: "eager" */ "/home/deployuser/infinitcode-ai/prod/infinitcode-ai-website/src/app/cookies-policy/page.tsx");
